import {Button, Form, Input,Select} from "antd";
import React from "react";
import Lang from "@components/Lang/Lang";
import './InputForm.less';
const { Option } = Select;

const InputForm = (props) => {
    const [form] = Form.useForm()
    const onFinish = (values) => {
        // console.log(values);
        Object.keys(values).forEach(key => {
            values[key] = values[key]&&values[key].trim()
        })
        props.getFormData && props.getFormData(values)
    };
    const onReset = () => {
        form.resetFields();
        let data = form.getFieldsValue()
        // console.log('data', data);
        props.getFormData && props.getFormData(data)
    };
    return (
        <Form className="input-form"
              name="afterSaleFilterForm"
              onFinish={onFinish}
              colon={false}
              form={form}
              layout="inline">

            <Form.Item
                name="statusMg">
                <Select defaultValue={""}
                        dropdownStyle={{zIndex:1}}
                        getPopupContainer={triggerNode => triggerNode.parentElement}
                        style={{ width: "132px" }}>
                    <Option value="">{Lang({id: 'QuanBuLeiXin', default: '全部类型'})}</Option>
                    {__getDictList('claim_demage_order_status_mg').map(item => (
                        <Option key={item.id} value={item.code}>{item.name}</Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item
                name="poCode"
                label={(
                    <span className="label-txt">
                    {Lang({id: 'GuanLianDanHao', default: '订单编号'})}
                </span>
                )}>
                <Input placeholder={Lang({id:'QingShuRu', default:'请输入'})} />
            </Form.Item>

            <Form.Item
                name="buyerCodeOrName"
                label={(
                <span className="label-txt">{Lang({id: 'CaiGouShang', default: '客户编号'})}</span>
            )}>
                <Input placeholder={Lang({id:'QingShuRu', default:'请输入'})} />
            </Form.Item>
            <Form.Item
                name="cdOrderCode"
                label={(
                <span className="label-txt">
                    {Lang({id: 'ShouHouDanHao', default: '售后单号'})}
                </span>
            )}>
                <Input placeholder={Lang({id:'QingShuRu', default:'请输入'})} />
            </Form.Item>

            <Form.Item >
                <Button type="blue" className="btn-little-blue" htmlType="submit">{Lang({id:'SouSuo', default:'SouSuo'})}</Button>
                <Button type="text" onClick={onReset} className="ml_8">
                    {Lang({id: 'ZhongZhi', default: '重置'})}
                </Button>
            </Form.Item>
        </Form>
    )
}

export default InputForm
